import { render, staticRenderFns } from "./MonthlyComment.vue?vue&type=template&id=6330ab86&scoped=true&"
import script from "./MonthlyComment.vue?vue&type=script&lang=js&"
export * from "./MonthlyComment.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyComment.vue?vue&type=style&index=0&id=6330ab86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6330ab86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
